// Whether a date has anything behind the "Cancellation terms" button. Every
// paid date does: the dialog always opens with the set date line (no 14-day
// right to cancel, MEET_SET_DATE_CANCELLATION_LINE), then the cancellation
// table and the club's terms where there are any. Free meets: never.
// Mirrored by the app's meet_cancellation_terms_sheet.dart hasCancellationTerms.
import {useMeetFormat} from '~/composables/useMeetFormat';

export const hasCancellationTerms = (meet, occurrence) => {
  const {isPaid} = useMeetFormat();
  return isPaid(meet);
};

// The words a member must see when booking INSIDE a cancellation window
// (owner, 11 Oct 2026): what cancelling from now would cost under the tier in
// force, and that a refilled spot is never charged (E17). Mirrored word for
// word by the app's meet_format.dart cancellationWarningText.
export const cancellationWarningText = ({percent, feeMinor, currency}) => {
  const code = (currency || 'gbp').toUpperCase();
  let charged;
  try {
    charged = new Intl.NumberFormat('en-GB', {style: 'currency', currency: code}).format(Math.round(feeMinor * percent / 100) / 100);
  } catch {
    charged = `${(Math.round(feeMinor * percent / 100) / 100).toFixed(2)} ${code}`;
  }
  if (percent >= 100) {
    return `You're inside the cancellation window, so this booking is non-refundable: cancel and the full ${charged} is charged. If someone takes your place, you're not charged.`;
  }
  return `You're inside the cancellation window: cancel and ${percent}% (${charged}) is charged. If someone takes your place, you're not charged.`;
};

// The warning for booking a date now, or null when cancelling is still free
// (outside every tier) or the date is free. The tier in force is the tightest
// window still ahead of the start, as the API's MeetRegisterRules.ApplicableTier.
export const bookingCancellationWarning = ({tiers, feeMinor, currency, startsAt, now = new Date()}) => {
  if (feeMinor == null || !tiers?.length || !startsAt) return null;
  const hoursUntil = (new Date(startsAt).getTime() - now.getTime()) / 3600000;
  const inForce = [...tiers].filter(t => hoursUntil < t.hoursBefore).sort((a, b) => a.hoursBefore - b.hoursBefore)[0];
  if (!inForce || inForce.chargePercent <= 0) return null;
  return cancellationWarningText({percent: inForce.chargePercent, feeMinor, currency});
};
